import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import BusinessDocumentManagement from './hellosign/HelloSignBusinessDocumentManagement';

const BusinessSettings: React.FC = () => {
    const { user } = useAuth();

    if (!user) {
        return (
            <div className="p-6 bg-gray-50 text-center">
                <p>Please log in to access business settings.</p>
            </div>
        );
    }

    // Get the business ID from the user object
    const businessId = user.businessId;

    if (!businessId) {
        return (
            <div className="p-6 bg-gray-50 text-center">
                <p>You need to be logged in as a business to access these settings.</p>
            </div>
        );
    }

    return (
        <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-900">Business Settings</h1>
                <p className="text-gray-600 mt-2">Manage your business settings and documents</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Sidebar */}
                <div className="md:col-span-1">
                    <div className="bg-white rounded-lg shadow p-6">
                        <h2 className="text-xl font-medium text-gray-900 mb-4">Settings Menu</h2>
                        <nav className="space-y-2">
                            <a href="#documents" className="block px-3 py-2 rounded-md bg-blue-50 text-blue-700 font-medium">
                                Document Management
                            </a>
                        </nav>
                    </div>
                </div>

                {/* Main content */}
                <div className="md:col-span-2">
                    <section id="documents" className="mb-12">
                        <BusinessDocumentManagement businessId={businessId} />
                    </section>

                    {/* Additional settings sections can be added here */}
                </div>
            </div>
        </div>
    );
};

export default BusinessSettings; 